// extracted by mini-css-extract-plugin
export default {"tablehead":"TableDbVersion_tablehead__M6NJm","custom-striped-table":"TableDbVersion_custom-striped-table__YoS8t","icon":"TableDbVersion_icon__oRFQp"};